import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Project from '../components/Project';

const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100%',
        height: 800,
        border: 0,
        [theme.breakpoints.down('xs')]: {
            height: 400,
        },
    },
}));

const Hypercasuals = () => {
    const classes = useStyles();
    const hypercasualsVideos = [
        {
            title: 'Spin and Shoot',
            src: 'https://drive.google.com/file/d/1dndC8JzH0xa-zhe1z6vSX0IBOlxW1d_g/preview',
        },
        {
            title: 'Zero Gravity 3D',
            src: 'https://drive.google.com/file/d/1tUkjc0F8CvmseiJVvLbYd51PgTtYneJS/preview',
        },
        {
            title: 'Caterpillar',
            src: 'https://drive.google.com/file/d/1M5m-IQdbNdO1zxM0vNMcWkTx3_HgdYP_/preview',
        },
        {
            title: 'Ball Dive',
            src: 'https://drive.google.com/file/d/1O9Uy9yc4ada3yBKdKqK29nKLupNZS4Wb/preview',
        },
        {
            title: 'Boat Runner 3D',
            src: 'https://drive.google.com/file/d/19-KaeVvOoQVchCQIIzMXnmeeIXobZhSI/preview',
        },
    ];

    return (
        <>
            <Project>
                <Grid
                    container
                    spacing={3}
                    justifyContent='center'
                    alignItems='center'
                    className='game-section'
                >
                    <Grid item xs={12}>
                        <Typography variant='h1' component='h1' gutterBottom>
                            Hyper Casual Games
                        </Typography>
                        <br />
                        <Typography>
                            In 2021 I decided to take a shot at the Hyper Casual
                            market. <br />
                            I've been producing 3D prototypes as a{' '}
                            <strong>solo developer</strong> and seeking
                            publishers to make a hit game with my own concepts.
                        </Typography>
                    </Grid>
                </Grid>
            </Project>
            <Grid
                container
                spacing={3}
                alignItems='center'
                justifyContent='center'
            >
                {hypercasualsVideos.map((h, i) => (
                    <Grid item xs={12} md={6} key={`hyper-casual-${i}`}>
                        <iframe
                            title={h.title}
                            src={h.src}
                            allow='autoplay'
                            className={classes.iframe}
                        ></iframe>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default Hypercasuals;
